import { Button } from '@common/components';

interface EmptySectionProps {
  mainMessage: string;
  subMessage?: string;
  actionButton?: {
    text: string;
    onClick: VoidFunction;
  };
}

export const EmptySection = ({
  mainMessage,
  subMessage,
  actionButton,
}: EmptySectionProps) => {
  return (
    <section className="flex-col break-keep px-20 py-150 text-center flex-center">
      <strong className="font-500 text-Gray-700 typo-body3">
        {mainMessage}
      </strong>
      {subMessage ? (
        <p className="whitespace-pre-wrap font-400 text-Gray-600 typo-body4">
          {subMessage}
        </p>
      ) : null}
      {actionButton ? (
        <Button
          className="mt-24 w-full"
          roundness="capsule"
          onClick={actionButton.onClick}
        >
          {actionButton.text}
        </Button>
      ) : null}
    </section>
  );
};
